import React from "react";
import { Link } from "react-router-dom";
import { ArgovLogo } from "@/components/ArgovLogo";

export default function NotFoundPage() {
  return (
    <div style={{ minHeight: "100vh", background: "#0c1a2e", color: "#fff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 40, textAlign: "center" }}>
      <div style={{ marginBottom: 32 }}><ArgovLogo size={72} /></div>
      <p className="font-mono" style={{ fontSize: 11, letterSpacing: "0.14em", color: "#0891b2", textTransform: "uppercase", marginBottom: 16 }}>404 — NOT FOUND</p>
      <h1 style={{ fontSize: 42, fontWeight: 800, letterSpacing: "-0.03em", marginBottom: 14 }}>Page not found.</h1>
      <p style={{ fontSize: 16, color: "#5e80a0", lineHeight: 1.65, maxWidth: 420, marginBottom: 36 }}>This asset is unregistered. In ARGOV™, unregistered assets are a policy violation. Let&apos;s get you back to governed territory.</p>
      <Link to="/" style={{ padding: "13px 28px", fontSize: 15, fontWeight: 600, background: "#0891b2", color: "#fff", borderRadius: 7, display: "inline-block" }}>Return to ARGOV™ →</Link>
    </div>
  );
}
